const responseCompanies = {
    "payload": [
        {
            "companyId": 164377,
            "name": "ViajaSha",
            "identificationType": "Número de Identificación Tributaria",
            "identificationId": 6,
            "identificationNumber": "12.321",
            "email": "prueba@prueba.com",
            "contactName": "devv",
            "contactNumber": "1321321",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/clients/164377-creaciondesdedev.png",
            "afiliateFee": 1.00,
            "monetizationIds": []
        },
        {
            "companyId": 164368,
            "name": "Empresa de dev",
            "identificationType": "Número de Identificación Tributaria",
            "identificationId": 6,
            "identificationNumber": "213.213",
            "email": "123@e.of",
            "contactName": "12321",
            "contactNumber": "21321321",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/clients/164368-3312.png",
            "afiliateFee": 123.00,
            "monetizationIds": []
        },
        {
            "companyId": 164381,
            "name": "Lucas",
            "identificationType": "Número de Identificación Tributaria",
            "identificationId": 6,
            "identificationNumber": "434.343",
            "email": "dfsf@342.co",
            "contactName": "dsfdsfs",
            "contactNumber": "312321321",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/clients/164381-4321.png",
            "afiliateFee": 3432.00,
            "monetizationIds": []
        },
        {
            "companyId": 164383,
            "name": "Solutions",
            "identificationType": "Número de Identificación Tributaria",
            "identificationId": 6,
            "identificationNumber": "434.343",
            "email": "dfsf@342.co",
            "contactName": "dsfdsfs",
            "contactNumber": "312321321",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/clients/164381-4321.png",
            "afiliateFee": 3432.00,
            "monetizationIds": []
        },
        {
            "companyId": 164384,
            "name": "FamilyMCI",
            "identificationType": "Número de Identificación Tributaria",
            "identificationId": 6,
            "identificationNumber": "434.343",
            "email": "dfsf@342.co",
            "contactName": "dsfdsfs",
            "contactNumber": "312321321",
            "icon": "https://ibliss-icons-dev.s3.amazonaws.com/clients/164381-4321.png",
            "afiliateFee": 3432.00,
            "monetizationIds": []
        },
    ]
}

const response = {
    "payload": [
        {
            "categoryId": 11,
            "name": "Ancianos",

        },
        {
            "categoryId": 12,
            "name": "Parque",

        }
    ]
}

const responseSub = {
    "payload": [
        {
            "subCategoryId": 10,
            "subCategoryName": "Jubilación",
            "product": [
                {
                    "productId": 131,
                    "productName": "Golf",
                    "price": 1221324.00,
                    "isAssigned": true
                },
                {
                    "productId": 132,
                    "productName": "Tenis",
                    "price": 21324.00,
                    "isAssigned": true
                },
            ]
        },
        {
            "subCategoryId": 9,
            "subCategoryName": "Arboleda",
            "product": [
                {
                    "productId": 130,
                    "productName": "Piscina",
                    "price": 1221323.00,
                    "isAssigned": true
                }
            ]

        }
    ]

}

const responseRes = {
    "payload": [
        {
            "productId": "felicidades"
        },

    ]
}

const responseFunctionalities = {
    "payload": [
        {
            "screenId": 1,
            "name": "Reconocimientos",
            "type": "APP"
        },
        {
            "screenId": 2,
            "name": "Dashboard",
            "type": "APP"
        },
        {
            "screenId": 3,
            "name": "Billetera",
            "type": "APP"
        }
    ]
}

export const service = {
    getCompanies: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCompanies }), 1000);
    }),

    getCategoriesMarketplaceProducts: () => new Promise(resolve => {
        setTimeout(resolve({ data: response }), 1000);
    }),

    getSubCategoriesMarketplaceProducts: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseSub }), 1000);
    }),

    postCreateProducts: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseRes }), 1000);
    }),

    getFunctionalities: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseFunctionalities }), 1000);
    }),
}